















import Vue, { VueConstructor } from 'vue';
import { PuzzleService } from "../../services/puzzleservice";
import { AxiosResponse } from 'axios';
export default Vue.extend({
  name: "GetPuzzle",
  data() {
    return {
      puzzleCode: "",
      notFound: false,
      focused: false,
      showMessage: false,
    };
  },
  mounted() { },
  methods: {
    getPuzzle: async function (): Promise<void> {
      try {
        const response: AxiosResponse = await PuzzleService.puzzleExists(this.puzzleCode);
        if (response.status === 200) {
          this.notFound = false;
          this.$router.push({
            name: "puzzle",
            params: { puzzleid: response.data }
          });
        } else {
          this.notFound = true;
        }
      } catch (error: any) {
        this.notFound = true;
        console.log(error);
      } finally {
        if (this.notFound) {
          this.showMessage = true;
        }
      }
    },
    focus: function (): void {
      this.focused = true;
    },
    blur: function (): void {
      this.focused = false;
    },
    closeMessage: function (): void {
      this.showMessage = false;

    },
  },
  watch: {
    puzzleCode: function (): void {
      this.puzzleCode = this.puzzleCode.toUpperCase();
    }
  }
});
